import type { Attendance } from '@/features/veluvit/types/api.types'
import type { AttendDay } from '@/features/veluvit/types/catalog.types'

export type AttendReward = {
  kind: 'gem' | 'ticket'
  amount: number
  label: string
}

/** 출석판 마지막 날(최종 보상 칸 — 크게 · 금색) */
export const FINAL_DAY = 7

/**
 * 출석 보상표 — 서버(bootstrap attendance.rewards)가 원본이다. 서버 값이 없을 때(첫 로딩 · 옛 응답)만 정적 카탈로그로 그린다.
 * 로얄 해금권은 없앴다(2026-10-07) — 서버가 아직 royalTickets 로 주면 일반 해금권 장 수로 합쳐 보인다.
 */
export function attendDays(
  rewards: Attendance['rewards'] | undefined,
  fallback: AttendDay[]
): AttendDay[] {
  if (!rewards?.length) return fallback
  return rewards.map((r) => ({
    d: r.day,
    r: '',
    gem: r.gem,
    ticket: (r.tickets || 0) + (r.royalTickets || 0) || undefined,
  }))
}

/** 출석 보상을 이모지 섞인 표시 문자열(r) 대신 구조로 읽는다 */
export function attendReward(day: AttendDay): AttendReward {
  if (day.ticket) return { kind: 'ticket', amount: day.ticket, label: '해금권' }
  return { kind: 'gem', amount: day.gem || 0, label: '젬' }
}

/** 다음 한국 시각 자정까지 남은 밀리초 */
export function msUntilMidnight(now: number) {
  const day = 86_400_000
  return day - ((now + 9 * 3_600_000) % day)
}
